import React from 'react';
import { ChefHatIcon, CompassIcon, LightbulbIcon, TrendingUpIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  compass: CompassIcon,
  chef: ChefHatIcon,
  bulb: LightbulbIcon,
  trending: TrendingUpIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-brand-cream" data-id="element-16" data-mp="3nnq7xmby2zgm">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="38qz9pge0btsl">
        <h2 id="beneficios" className="font-display text-base font-extrabold leading-tight text-brand-choco sm:text-xl" data-id="element-18" data-mp="3dqvg1ma6fxbb">
          ¿Qué puede cambiar cuando empezás?
        </h2>
        <p className="mx-auto mt-1 max-w-xl font-script text-[0.9rem] italic leading-snug text-brand-pinkdark" data-id="element-19" data-mp="34px9aw8ctbp1">
          Aprender pastelería puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="12ysghwuoq534">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border border-brand-blush bg-white p-2.5 text-left" data-id="element-21" data-mp="2bd2wbhl14ilf" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-brand-gold" data-id="element-22" data-mp="2g5e04viw4oj9">
                  <Icon size={15} className="text-white" data-id="element-23" data-mp="1shcsrpxg7e5f" />
                </span>
                <div data-id="element-24" data-mp="1of80ovmnepkw">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight text-brand-pink" data-id="element-25" data-mp="1og1doec7abbh">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-[0.76rem] leading-snug text-brand-choco/80" data-id="element-26" data-mp="1xev5lrel6dip">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}